import React from 'react';
import './HomeStudentLife.css';

import image1 from '../../../assets/Hall 3.jpg'; 
import image2 from '../../../assets/sports.jpg';
import image3 from '../../../assets/visit.jpg'; 
import image4 from '../../../assets/yoga.jpeg';
import image5 from '../../../assets/Ground.png';
import image6 from '../../../assets/Library.png';
import image7 from '../../../assets/garden.jpg';
import image8 from '../../../assets/group.jpeg';

function HomeStudentLife() {
  return (
    <section className="home-student-life-section">
      <div className="home-student-life-container">

        {/* --- Section Header --- */}
        <div className="home-student-life-header">
          <h2 className="home-student-life-main-title">A Vibrant Campus Life</h2>
          <p className="home-student-life-subtitle">
            At SK College, education extends beyond the classroom. We foster a supportive and dynamic environment where students can grow, learn, and create lasting memories.
          </p>
        </div>

        {/* --- Image Gallery Grid --- */}
        <div className="home-student-life-gallery-grid">

          {/* Gallery Item 1 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image1} 
              alt="Interactive College Hall" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Interactive Halls</h3>
            </div>
          </div>

          {/* Gallery Item 2 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image2} 
              alt="Comfortable Girls Hostel" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Sports Facilities</h3>
            </div>
          </div>

          {/* Gallery Item 3 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image3} 
              alt="Experienced Teaching Staff" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Celebrity Visit</h3>
            </div>
          </div>

          {/* Gallery Item 4 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image4} 
              alt="Yoga and Wellness Activities" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Yoga & Wellness</h3>
            </div>
          </div>

        </div>

        <div className="home-student-life-gallery-grid reverse-layout">

          {/* Gallery Item 5 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image5} 
              alt="Interactive College Hall" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Play Ground</h3>
            </div>
          </div>

          {/* Gallery Item 6 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image6} 
              alt="Comfortable Girls Hostel" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Library</h3>
            </div>
          </div>

          {/* Gallery Item 7 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image7} 
              alt="Experienced Teaching Staff" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Garden</h3>
            </div>
          </div>

          {/* Gallery Item 8 */}
          <div className="home-student-life-gallery-item">
            <img 
              src={image8} 
              alt="Yoga and Wellness Activities" 
              className="home-student-life-image"
            />
            <div className="home-student-life-overlay">
              <h3 className="home-student-life-title">Group</h3>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HomeStudentLife;